import React from "react";

const WelcomeIcon = () => {
  return (
    <div className="welcome-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122 180" fill="none">
        <path
          d="M51.4133 68.1794H27.876V65.3133C27.876 63.5762 29.2657 62.1865 31.0027 62.1865H49.1551C50.371 62.1865 51.4133 63.2288 51.4133 64.4447V68.1794Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M67.9157 63.751C67.134 65.488 64.2679 69.3965 63.3993 71.1335C63.2256 71.6546 62.9651 72.0889 62.7913 72.5232C62.2702 73.5654 61.7491 74.6945 60.9674 75.5631C60.4463 76.2579 59.5778 76.779 58.7961 76.6053C58.3618 76.6053 57.9275 76.4316 57.8407 76.0842C57.3196 75.6499 56.9722 75.0419 56.6248 74.3471C56.1905 73.9128 55.7562 73.4786 55.322 73.0443C54.6271 72.2626 54.0191 71.4809 53.498 70.6993C53.0637 70.0913 52.7163 69.3965 52.3689 68.7016C51.5872 68.1805 50.7187 67.5725 49.8501 67.1383C42.815 68.8753 38.0381 72.0021 38.0381 75.6499C38.0381 78.4292 40.8174 80.948 45.3338 82.6851C45.247 82.2508 45.1601 81.8165 45.1601 81.4691C45.1601 80.1663 45.4206 78.8635 46.0286 77.7344C46.2023 77.3001 46.984 77.0396 47.592 77.2133C46.8971 76.5184 46.2892 75.7368 45.6812 75.0419C44.9864 74.1734 46.8103 73.3917 47.5051 74.1734C49.5028 76.5184 51.6741 78.8635 53.9323 81.1217C54.9745 82.2508 56.0168 83.3799 57.1459 84.4221C57.3196 84.5958 57.5801 84.7695 57.7539 84.9432C58.7092 85.1169 59.8383 85.2907 60.7937 84.8564C61.4886 84.509 61.9228 83.901 62.1834 83.3799C63.3125 81.556 64.181 79.732 65.0495 77.9081C66.8734 74.0866 68.35 70.265 69.3054 66.2697C68.1763 66.1829 69.0448 63.8378 67.9157 63.751Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M70.0879 0.608398C70.9565 0.608398 71.6513 1.30322 71.6513 2.17176V124.027C71.6513 124.809 70.6959 125.417 69.4799 125.417C68.264 125.417 67.3086 124.809 67.3086 124.027V2.17176C67.3086 1.30322 68.0034 0.608398 68.8719 0.608398H70.0879Z"
          fill="#253143"
        />
        <path
          d="M72.3457 4.51725C72.3457 2.51962 73.8222 1.47737 75.6461 2.1722L119.941 19.1086C121.765 19.8035 122.286 21.6274 121.071 23.1908L113.254 33.0921C112.038 34.6554 111.777 37.261 112.733 38.9981L121.592 54.7186C122.547 56.4557 121.765 58.2796 119.855 58.7139C119.855 58.7139 118.899 58.9744 116.988 58.1927C101.876 52.4604 75.5593 39.8666 75.5593 39.8666C73.8222 38.9981 72.3457 36.7399 72.3457 34.7423V4.51725Z"
          fill="#BF4E26"
        />
        <path
          d="M75.6452 9.98973H68.1758L69.1311 4.17055L73.4738 2.25977L75.6452 9.98973Z"
          fill="#9A4028"
        />
        <path
          d="M68.0898 6.25455C68.0898 4.25692 69.5664 3.21467 71.3903 3.9095L115.686 20.8459C117.51 21.5408 118.031 23.3647 116.815 24.9281L108.998 34.8294C107.782 36.3927 107.521 38.9983 108.477 40.7354L117.336 56.4559C118.291 58.193 117.596 58.9747 115.772 58.2798L71.4772 41.3434C69.6532 40.6486 68.1767 38.4772 68.1767 36.4796V6.25455H68.0898Z"
          fill="#EA6B3D"
        />
        <path
          d="M92.9543 32.0069C92.9543 32.0069 91.9988 35.5679 91.3909 35.3074L89.9144 32.8755L87.5693 32.0069L85.6585 33.5703L84.6163 28.7933C84.5294 28.2722 84.6163 27.7511 84.9637 27.4037L85.0506 27.1431L86.3534 25.3192L86.1796 21.8451C86.1796 21.4976 86.2665 21.2371 86.4402 20.9765L88.6116 18.1104L90.696 22.3662C90.9566 22.8004 91.0435 23.3216 91.0435 23.7558L90.9566 26.7957L92.7805 30.6173C92.9542 31.1384 93.0411 31.5727 92.9543 32.0069Z"
          fill="white"
        />
        <path
          d="M97.0848 48.9396C97.0848 49.1085 97.0849 49.2775 97.0035 49.3619L79.6654 42.6893C79.6654 42.5204 79.584 42.3515 79.584 42.1825C79.584 41.0845 80.5608 40.4933 81.7004 40.9156L81.8632 41C82.6772 39.9865 84.3866 40.2399 85.7704 41.5913C86.0146 41.7602 86.1774 42.0136 86.3402 42.267C86.503 42.267 86.6658 42.267 86.7472 42.3515L87.3169 36.8613L89.5147 37.706L89.9217 43.6184C90.0845 43.7029 90.2473 43.7873 90.3287 43.8718C91.3869 43.1961 93.1777 43.7873 94.3173 45.2232C94.4801 45.4766 94.6429 45.73 94.8057 45.9834L94.9685 46.0679C96.1895 46.4902 97.0848 47.8416 97.0848 48.9396Z"
          fill="white"
        />
        <path
          d="M24.2274 102.921C25.0908 102.921 25.7908 101.444 25.7908 99.6208C25.7908 97.798 25.0908 96.3203 24.2274 96.3203C23.364 96.3203 22.6641 97.798 22.6641 99.6208C22.6641 101.444 23.364 102.921 24.2274 102.921Z"
          fill="#E5CAC7"
        />
        <path
          d="M33.1738 66.2684C33.6949 67.6581 34.824 68.1792 36.3005 68.5266C38.4719 69.0477 40.9906 68.874 42.9014 67.7449C43.7699 67.3107 44.4648 66.6158 44.8991 65.7473C44.8122 65.6604 44.8122 65.6604 44.7253 65.5736C43.4225 64.7051 42.2066 63.6628 41.5986 62.1863C41.4249 61.8389 41.3381 61.4046 41.2512 60.9703C42.6409 60.015 43.5094 58.191 43.5094 56.2802C43.5094 53.1535 41.3381 50.6348 38.6456 50.6348C35.9531 50.6348 33.7818 53.1535 33.7818 56.2802C33.7818 58.3647 34.7372 60.1887 36.2137 61.1441C36.2137 62.5337 35.8663 63.9234 34.5635 64.8788C34.0423 65.313 33.7818 66.0078 33.1738 66.2684Z"
          fill="#E5CAC7"
        />
        <path
          d="M57.8401 135.23C57.6664 136.359 55.582 136.88 53.1501 136.446C50.805 136.012 48.9811 134.622 49.2417 133.493C49.2417 133.319 49.3285 133.146 49.5022 132.972C49.4154 131.235 49.3285 129.498 49.1548 127.848C48.1125 124.808 47.0703 121.681 46.2018 118.641C44.6384 113.343 43.4224 107.958 41.7722 102.66C41.4248 101.444 39.8615 101.878 39.7746 102.921C39.6878 103.008 39.6009 103.181 39.5141 103.355C37.8638 109 36.7347 114.82 35.0845 120.465C34.216 123.331 33.2606 126.111 32.1315 128.803C31.6972 129.845 31.263 130.801 30.8287 131.843C30.655 132.625 30.5681 133.406 30.4813 134.188C30.1339 135.143 28.9179 136.272 27.1808 137.054C24.9226 138.009 22.8382 137.923 22.4039 136.88C21.9696 135.838 23.4461 134.188 25.7043 133.146C26.7466 132.711 27.7019 132.451 28.5705 132.451C29.1785 119.944 31.0024 107.611 32.3921 95.1907C32.9132 93.3668 33.2606 91.5428 33.1738 89.6321C33.1738 89.5452 33.1738 89.4584 33.1738 89.4584C37.6901 89.3715 42.2065 89.4583 46.7229 89.7189C46.636 89.8926 46.6361 90.1532 46.6361 90.4137V90.5006C46.7229 90.5006 46.8098 90.5006 46.8966 90.4137C47.5046 93.9747 48.2862 97.4489 49.1548 100.923C49.3285 101.705 49.5022 102.573 49.6759 103.355C50.3708 106.134 51.1524 108.914 51.7604 111.78C53.15 118.554 53.3237 125.503 53.9317 132.364C54.0186 132.364 54.1054 132.364 54.1923 132.364C56.2768 132.711 58.0138 134.101 57.8401 135.23Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M49.5893 75.1281C49.5893 73.9121 49.763 72.783 50.1104 71.6539C50.4578 70.438 50.9789 69.3089 51.5 68.1798C49.763 66.4427 47.4179 64.6188 44.8123 64.5319C44.6386 64.5319 44.4649 64.5319 44.2912 64.5319C44.1175 64.3582 43.9438 64.2714 43.6832 64.0977C41.3382 66.3558 37.0823 66.877 34.6504 64.5319C34.5636 64.5319 34.5636 64.6188 34.4768 64.6188C33.9556 65.4873 32.9134 66.6164 31.958 66.3559C29.4392 65.8347 29.005 66.7901 28.6576 68.3535C28.4839 69.1352 28.7444 71.0459 28.4839 71.7408C28.2233 72.8699 27.9627 73.999 27.789 75.1281C27.789 75.3018 27.789 75.4755 27.7021 75.6492C27.7021 75.736 27.7021 75.8229 27.7021 75.8229C27.789 79.297 28.4838 82.7712 29.6129 86.0716C30.6552 89.1115 32.1317 91.9776 33.5213 94.9307C33.6082 94.9307 33.6951 94.9307 33.6951 94.9307C37.4298 95.2781 41.3382 95.1912 45.0729 94.149C45.6808 93.9753 46.202 93.7147 46.5494 93.4542C46.5494 93.3673 46.5494 93.2805 46.6363 93.1936C49.6761 87.5481 49.6761 81.3815 49.5893 75.1281Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M43.0744 54.6293C40.0345 53.7607 36.7341 54.195 33.6942 55.0635C33.6074 54.6293 33.5205 54.195 33.5205 53.7607C33.5205 50.634 35.7787 48.1152 38.558 48.1152C41.3373 48.1152 43.5956 50.634 43.5956 53.7607C43.5956 54.195 43.5955 54.5424 43.5087 54.9767C43.4218 54.803 43.2481 54.7161 43.0744 54.6293Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M36.8219 49.0716C37.8772 49.0716 38.7327 48.2161 38.7327 47.1608C38.7327 46.1055 37.8772 45.25 36.8219 45.25C35.7666 45.25 34.9111 46.1055 34.9111 47.1608C34.9111 48.2161 35.7666 49.0716 36.8219 49.0716Z"
          fill="url(#paint5_linear)"
        />
        <path
          d="M29.9595 76.4307C30.828 74.7805 31.1754 73.0434 30.7411 71.2195C30.3069 69.6562 29.6989 68.1796 29.2647 66.7031C21.5347 77.9941 22.0558 88.5034 22.7506 99.968H25.7905C26.3985 92.3249 27.9619 84.8555 29.0909 77.2124C29.0909 76.7781 29.5252 76.5176 29.9595 76.4307Z"
          fill="url(#paint6_linear)"
        />
        <path
          d="M71.3024 68.7874C72.3097 68.7874 73.1264 67.3097 73.1264 65.487C73.1264 63.6642 72.3097 62.1865 71.3024 62.1865C70.2951 62.1865 69.4785 63.6642 69.4785 65.487C69.4785 67.3097 70.2951 68.7874 71.3024 68.7874Z"
          fill="#E5CAC7"
        />
        <path
          d="M45.5942 63.751H45.5073H45.4205C45.3337 63.8378 45.2468 63.8378 45.2468 63.9247L45.16 64.0115L45.0731 64.0984C44.9862 64.1852 44.9863 64.2721 44.8994 64.3589C45.16 68.2674 46.0285 72.0021 47.3313 75.6499C47.7656 77.0396 48.2867 78.4292 48.8947 79.8189C49.1552 80.4269 49.5026 81.0348 49.85 81.6428C49.7632 79.4715 49.6763 77.2133 49.7632 75.0419C48.5472 72.0021 47.7655 68.8753 47.6787 65.6618C47.6787 65.488 47.7655 65.3143 47.8524 65.2275V65.1406C47.8524 65.0538 47.7656 64.9669 47.7656 64.9669C47.7656 64.9669 47.7656 64.9669 47.7656 64.8801C47.7656 64.7932 47.6787 64.7932 47.6787 64.7064C47.5918 64.6195 47.5919 64.5327 47.505 64.4458L47.4181 64.3589C47.3313 64.2721 47.2444 64.1852 47.1576 64.1852L47.0708 64.0984C46.897 64.0115 46.7233 63.9247 46.5496 63.8378H46.4628H46.3759L45.5942 63.751Z"
          fill="url(#paint7_linear)"
        />
        <path
          d="M29.0921 84.4222C29.2659 84.9434 29.5264 85.3776 29.787 85.8987C30.6555 83.0326 31.6109 80.1664 32.3057 77.2134C33.0874 73.7392 33.1742 70.5257 32.6531 67.0515C32.5663 66.9647 32.5663 66.8778 32.4794 66.791C32.4794 66.7041 32.3926 66.6173 32.3926 66.5304V66.4436V66.3567C32.3057 66.183 32.2189 66.0961 32.132 65.9224L32.0451 65.8356C31.9583 65.7487 31.9583 65.7487 31.8715 65.6619C31.8715 65.6619 31.8714 65.6619 31.7846 65.575C31.6977 65.575 31.6977 65.4882 31.6109 65.4882C31.524 65.4882 31.5241 65.4013 31.4372 65.4013C31.3503 65.4013 31.1766 65.4013 31.0898 65.3145H31.0029C30.9161 65.3145 30.9161 65.3145 30.8292 65.3145C30.7424 65.3145 30.7423 65.3145 30.6555 65.3145C30.5686 65.4013 30.3949 65.4013 30.3081 65.4013C30.2212 65.4013 30.2212 65.4013 30.1344 65.4882C30.0475 65.575 29.9606 65.575 29.8738 65.6619C29.7869 65.6619 29.787 65.7487 29.7001 65.7487C29.6133 65.8356 29.6133 65.8356 29.7001 65.7487C29.6133 65.8356 29.5264 65.9224 29.4395 66.0093L29.3527 66.0961C29.2658 66.183 29.2658 66.2698 29.179 66.3567C29.179 66.4435 29.179 66.4435 29.179 66.5304C29.179 66.6173 29.179 66.6172 29.179 66.7041V66.791C29.3527 66.791 29.5264 66.9647 29.6132 67.1384C31.9583 71.6548 30.1344 76.866 28.6579 81.5561C28.6579 81.6429 28.6579 81.7298 28.6579 81.8166C28.571 82.9457 28.7447 83.6406 29.0921 84.4222Z"
          fill="url(#paint8_linear)"
        />
        <path
          d="M73.7358 122.291L79.2076 154.079L64.5293 119.077L70.5222 119.425C72.1724 119.598 73.4752 120.814 73.7358 122.291Z"
          fill="#919DA8"
        />
        <path
          d="M19.6263 138.098L1.82129 178.138L50.8935 134.537L23.4478 135.579C21.7108 135.666 20.3211 136.622 19.6263 138.098Z"
          fill="#C5CDD8"
        />
        <path
          d="M85.4602 179.311H48.9014L64.6153 118.253L79.2936 153.255L85.4602 179.311Z"
          fill="#EDF2F9"
        />
        <path
          d="M64.6157 119.163L0 179.632H51.8957L64.6157 119.163Z"
          fill="#D9DDE3"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="28.2359"
            y1="61.4392"
            x2="29.4598"
            y2="74.6558"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0254815" stopColor="#2E3B4B" />
            <stop offset="0.97" stopColor="#253143" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="46.5246"
            y1="62.1068"
            x2="54.2443"
            y2="88.8575"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0446927" stopColor="#F9B42E" />
            <stop offset="1" stopColor="#C8A527" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="22.8714"
            y1="83.4031"
            x2="65.5505"
            y2="169.72"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0254815" stopColor="#567192" />
            <stop offset="0.629015" stopColor="#1E2A3E" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="34.1613"
            y1="61.7122"
            x2="51.9166"
            y2="93.9887"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0446927" stopColor="#FFE872" />
            <stop offset="1" stopColor="#BC9714" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="36.2551"
            y1="47.5808"
            x2="38.7825"
            y2="56.2637"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0446927" stopColor="#EB774C" />
            <stop offset="1" stopColor="#BA451B" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="35.9484"
            y1="44.9561"
            x2="37.8042"
            y2="49.353"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0446927" stopColor="#EB774C" />
            <stop offset="1" stopColor="#BA451B" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="24.7036"
            y1="64.1447"
            x2="44.7273"
            y2="76.329"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0446927" stopColor="#FFE872" />
            <stop offset="1" stopColor="#BC9714" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="44.9751"
            y1="61.5197"
            x2="64.1521"
            y2="76.109"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0254815" stopColor="#567192" />
            <stop offset="0.629015" stopColor="#1E2A3E" />
          </linearGradient>
          <linearGradient
            id="paint8_linear"
            x1="28.7022"
            y1="62.7474"
            x2="48.5813"
            y2="74.2869"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0254815" stopColor="#567192" />
            <stop offset="0.629015" stopColor="#1E2A3E" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default WelcomeIcon;
